import React, { FC } from 'react';
import { Bar, BarChart, Cell, LabelList, ResponsiveContainer, XAxis, YAxis } from 'recharts';
import { CustomXAxisTick } from '../../../shared/components/custom-x-axis-tick/custom-x-axis-tick.component';
import { IProgressBar } from '../../models';
import { useGetProgressColor } from '../../utils';
import { renderBlacklistedLabel } from './blacklisted-label.component';
import { renderWarningLabel } from './warning-label.component';

interface Props {
    progresses: IProgressBar[];
    showLabels: boolean;
}

export const ProgressChart: FC<Props> = ({ progresses, showLabels }) => {
    const getFill = useGetProgressColor();
    const maxAmountOfCharsPerLine = Math.max(1, Math.floor(140 / progresses.length));
    const fontSize = progresses.every((progress) => {
        return maxAmountOfCharsPerLine > (progress.name?.length || 0);
    })
        ? 16
        : 12;

    return (
        <ResponsiveContainer width="100%" height={150} id="organisation-progress-categories">
            <BarChart margin={{ top: 20, bottom: 20 }} data={progresses}>
                {showLabels && (
                    <XAxis
                        dataKey="name"
                        tick={<CustomXAxisTick maxAmountOfCharsPerLine={maxAmountOfCharsPerLine} fontSize={fontSize} />}
                        interval={0}
                        fontSize={fontSize}
                    />
                )}
                {!showLabels && <XAxis dataKey="abbreviation" stroke="black" fontSize="9px" interval={0} />}
                <YAxis label={{ value: '%', position: 'insideLeft' }} domain={[0, 100]} hide={!showLabels} />
                <Bar dataKey="percentage" isAnimationActive={false} stackId="a">
                    {showLabels && <LabelList dataKey="label" position="top" fill="black" strokeWidth={0.1} />}
                    {!showLabels && <LabelList dataKey="showWarning" content={renderWarningLabel} />}
                    {!showLabels && <LabelList dataKey="isBlacklisted" content={renderBlacklistedLabel} />}
                    {!showLabels && <LabelList dataKey="limit" position="top" fill="black" strokeWidth={0.1} />}
                    {progresses.map((progress) => (
                        <Cell
                            fill={getFill(progress)}
                            key={progress.category}
                            fontSize="11px"
                            stroke={getFill(progress)}
                            strokeWidth={2}
                        />
                    ))}
                </Bar>
                <Bar dataKey="percentageNotScanned" stackId="a" fill="#ffffff00" strokeWidth={2}>
                    {progresses.map((progress) => (
                        <Cell stroke={getFill(progress)} key={progress.category} />
                    ))}
                </Bar>
            </BarChart>
        </ResponsiveContainer>
    );
};
